import type { SWRConfiguration } from 'swr';

export const globalSWRConfig: SWRConfiguration = {
  /**
   * If true, SWR will make multiple calls, which is pointless
   */
  shouldRetryOnError: false,
  /**
   * If true, SWR will re-fetch when the user refocuses the tab
   * (or clicks back on the page after having focused on DevTools)
   */
  revalidateOnFocus: false
};
